import proj4 from "proj4";
(window as any).proj4 = proj4;   // expose a real function to consumers that look for global proj4
import "proj4-fully-loaded";     // optional but handy: loads common EPSG defs

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import 'leaflet/dist/leaflet.css';


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
